// src/use-effect-event.tsx
import { useLayoutEffect } from "@radix-ui/react-use-layout-effect";
import * as React from "react";
var useReactEffectEvent = React[" useEffectEvent ".trim().toString()];
var useReactInsertionEffect = React[" useInsertionEffect ".trim().toString()];

function useEffectEvent(callback) {
  if (typeof useReactEffectEvent === "function") {
    return useReactEffectEvent(callback);
  }

  var ref = React.useRef(function () {
    throw new Error("Cannot call an event handler while rendering.");
  });

  if (typeof useReactInsertionEffect === "function") {
    useReactInsertionEffect(function () {
      ref.current = callback;
    });
  } else {
    useLayoutEffect(function () {
      ref.current = callback;
    });
  }

  return React.useMemo(function () {
    return function () {
      var _ref$current;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.call.apply(_ref$current, [ref].concat(args));
    };
  }, []);
}

export { useEffectEvent };